import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { CardTransaction } from '@models/card-transactions/card-transaction.model';
import { BaseQueryFilter } from '@models/base-query-filter.model';

import { QueryConfig } from '@app/shared/utils/query-config.utils';
import { PagedResponse } from '@models/commons/paged-response.model';
import { AppUtils } from '@app/shared/utils/app.utils';

import { Observable } from 'rxjs';

import { environment } from 'environments/environment';
import { CardTransactionFilter } from '@app/shared/models/card-transactions/card-transaction-filter.model';

@Injectable({
  providedIn: 'root'
})
export class CardTransactionsService {
  static readonly API_CARDS_BASE_PATH = `${environment.api.rest.cards}`;

  constructor(private http: HttpClient) {
  }

  loadCardTransactions(config: QueryConfig): Observable<PagedResponse<CardTransaction>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get<PagedResponse<CardTransaction>>(`${CardTransactionsService.API_CARDS_BASE_PATH}/transactions`, {params});
  }

  loadCardTransaction(id: number): Observable<CardTransaction> {
    return this.http.get<CardTransaction>(`${CardTransactionsService.API_CARDS_BASE_PATH}/transactions/${id}`);
  }

  downloadCardTransactionsReport(config: QueryConfig): Observable<HttpResponse<Blob>> {
    const params = AppUtils.buildPageableParams(config);
    return this.http.get(`${CardTransactionsService.API_CARDS_BASE_PATH}/transactions/report`, {
      params,
      observe: 'response',
      responseType: 'blob'
    });
  }

  loadSuppliers(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/suppliers`, {params});
  }

  loadCardCategories(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/categories`, {params});
  }

  loadCardNumbers(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/cardNumbers`, {params});
  }

  loadRegistrationNumbers(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/registrationNo`, {params});
  }

  loadCostCenters(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/costCenters`, {params});
  }

  loadCardNames(customerNo: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('customerNo', customerNo);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/cardNames`, {params});
  }

  loadServiceCodes(supplier: string): Observable<BaseQueryFilter[]> {
    const params = new HttpParams().set('supplier', supplier);
    return this.http.get<BaseQueryFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/codeService`, {params});
  }

  loadCardTransactionFilters(customerNo: string): Observable<CardTransactionFilter[]> {
    const params = new HttpParams().set('supplier', customerNo);
    return this.http.get<CardTransactionFilter[]>(`${CardTransactionsService.API_CARDS_BASE_PATH}/cardFilters`, {params});
  }
}
